export default "__VITE_ASSET__DqB8FUtQ__"